import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopencabservice() {



  const cardData = {
"keyword": "Pune to Pen Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Pen Cab Service for travelers seeking safe, affordable, and convenient transportation towards the Konkan region of Maharashtra. Whether you are planning a family visit, business travel, weekend trip, industrial visit, pilgrimage, or coastal exploration, our taxi service ensures a smooth and stress-free journey. With experienced drivers who are well-versed with highway and ghat routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Pen. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and well-planned journey to Pen and nearby Konkan destinations.",

"topPlaces": [
  {
    "title": "Pen City Center",
    "description":
      "Pen is a well-known town in Raigad district famous for its Ganpati idol-making industry, local markets, and connectivity to Mumbai and Konkan regions. It is a key stop for travelers moving between Pune and coastal Maharashtra."
  },
  {
    "title": "Ganpati Idol Making Workshops",
    "description":
      "Pen is internationally famous for its handcrafted Ganesh idols made by skilled artisans. Visitors often explore workshops to see traditional idol-making during Ganesh festival preparations."
  },
  {
    "title": "Karnala Bird Sanctuary (Nearby)",
    "description":
      "Karnala Bird Sanctuary is located near the Pune–Pen route and is known for its biodiversity, migratory birds, and trekking trails leading to Karnala Fort."
  },
  {
    "title": "Karnala Fort",
    "description":
      "Karnala Fort is a historic hill fort located inside the bird sanctuary area, offering trekking opportunities and panoramic views of the surrounding Western Ghats."
  },
  {
    "title": "Kalamboli Junction Route",
    "description":
      "The route connecting Pen includes major highway junctions near Kalamboli, providing smooth connectivity towards Mumbai, Navi Mumbai, and Pune."
  },
  {
    "title": "Alibaug Extension Route",
    "description":
      "Pen serves as a connecting point to Alibaug and nearby coastal beaches, making it an important route for weekend beach travelers from Pune."
  },
  {
    "title": "Panvel Industrial Belt",
    "description":
      "The nearby Panvel industrial and urban region is a major commercial hub, often included in travel routes between Pune, Pen, and Mumbai."
  },
  {
    "title": "Raigad Coastal Region",
    "description":
      "Pen lies in the Raigad district, which is known for its coastal landscapes, forts, rivers, and Konkan culture, forming part of the scenic Maharashtra coastline."
  },
  {
    "title": "Dharamtar Creek Area",
    "description":
      "Dharamtar Creek near Pen is a calm water body known for scenic views, fishing activity, and ferry connections in the Raigad coastal belt."
  },
  {
    "title": "Konkan Gateway Route",
    "description":
      "The Pune to Pen cab route serves as a gateway to the Konkan region, connecting travelers to beaches, forts, industrial zones, and cultural destinations across Maharashtra."
  }
],



services: [
  {
    name: "Pune to Pen Cab",
    description: "Pune to Pen cab service provides reliable transportation for passengers traveling between Pune and Pen with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance Raigad highway travel ensuring smooth and timely journeys for families, tourists, corporate travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Pen cab reservations."
  },
  {
    name: "Pune to Pen Taxi",
    description: "Pune to Pen taxi service offers dependable transportation for Raigad and Konkan outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, family travel, tourism, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Pen taxi reservations."
  },
  {
    name: "Cab from Pune to Pen",
    description: "Cab from Pune to Pen service provides comfortable transportation for passengers traveling from Pune to Pen and nearby destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Pen",
    description: "Taxi from Pune to Pen service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Pen. Vehicles provide smooth city and highway travel suitable for tourism, business visits, Raigad district travel, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Pen Cab Service",
    description: "Pune to Pen cab service provides dependable transportation solutions for outstation travel between Pune and Pen. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, Raigad sightseeing, and family outstation travel. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Pen Taxi Fare",
    description: "Pune to Pen taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Pen. Travelers can enjoy smooth journeys with experienced drivers familiar with highway routes and ghat road conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Pen One Way Cab",
    description: "Pune to Pen one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Pen. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, Raigad visits, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Pen Round Trip Taxi",
    description: "Pune to Pen round trip taxi service offers spacious transportation for families and groups traveling between Pune and Pen with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and Konkan travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Pen Cab Booking",
    description: "Pune to Pen cab booking service provides premium transportation for passengers seeking comfortable and reliable outstation travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Pen Cab",
    description: "Cheap Pune to Pen cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Pen. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Pen Taxi",
    description: "Best Pune to Pen taxi service offers dependable transportation for passengers planning direct outstation travel between Pune and Pen. Comfortable vehicles ensure smooth highway travel suitable for tourism, business travel, Raigad sightseeing, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Pen Cab",
    description: "Sedan Pune to Pen cab service provides reliable transportation for travelers planning long-distance journeys between Pune and Pen. Sedan vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and vacation travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Pen Taxi",
    description: "SUV Pune to Pen taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Pen. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business trips, family tours, Konkan travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Pen Cab",
    description: "Innova Pune to Pen cab service provides dependable transportation for passengers planning premium outstation travel between Pune and Pen. Innova vehicles ensure smooth highway travel suitable for tourism, Konkan tours, Raigad district visits, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Raigad District Cab Pune Pen",
    description: "Raigad district cab Pune Pen service provides affordable and convenient transportation for passengers traveling between Pune and Pen through scenic Raigad routes. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for tourists, family travelers, Raigad sightseeing trips, and long-distance outstation travel requirements. Flexible booking options allow convenient Raigad district cab reservations."
  }
],

tableData: [
  ["Pune to Pen Cab", "Pune to Pen Taxi"],
  ["Cab from Pune to Pen", "Taxi from Pune to Pen"],
  ["Pune to Pen Cab Service", "Pune to Pen Taxi Fare"],
  ["Pune to Pen One Way Cab", "Pune to Pen Round Trip Taxi"],
  ["Pune to Pen Cab Booking", "Cheap Pune to Pen Cab"],
  ["Best Pune to Pen Taxi", "Sedan Pune to Pen Cab"],
  ["SUV Pune to Pen Taxi", "Innova Pune to Pen Cab"],
  ["Raigad District Cab Pune Pen", "Pune to Pen Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Pen Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Pen cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe outstation travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Pen Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Pen cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Pen Cab Availability",
        WhyChoosedescription: "Our Pune to Pen cab service operates 24 hours a day for family travel, business trips, Konkan journeys, industrial visits, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Pen taxi service, round-trip bookings, Konkan travel, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, tourists, and corporate travelers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Pen highway routes and ensure safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Pen cab service?", answer: "Pune to Pen cab service provides comfortable taxi transportation between Pune and Pen for family travel, business trips, and outstation journeys." },
    { question: "Is Pune to Pen cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Pen cab service." },
    { question: "Which vehicles are available for Pune to Pen travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Pen?", answer: "Yes, customers can book one-way as well as round-trip Pune to Pen taxi services." },
    { question: "Do you provide round-trip taxi service for Pen travel?", answer: "Yes, Shivai Travels provides both one-way and round-trip taxi services for Pen." },
    { question: "Are all Pune to Pen taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Pen cab service online?", answer: "Yes, customers can easily book Pune to Pen cab service online or through phone booking." },
    { question: "Do you provide cabs for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and corporate transportation." },
    { question: "Are Pune to Pen cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Pen cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Nikhil Deshmukh",
      feedback:
        "Booked Pune to Pen cab service with Shivai Travels. Comfortable vehicle, smooth journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Kulkarni",
      feedback:
        "Excellent Pune to Pen taxi service. Affordable pricing, clean cab, and very professional travel experience.",
      rating: 5
    }
  ];;






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pen Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-pen-cab.jpg",
  "description": "Book Pune to Pen Cab Service for safe and comfortable Raigad district travel. Shivai Travels offers reliable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for intercity and highway journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-pen-cab-service"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Pen Cab Service | Raigad Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Pen cab service for safe Raigad district travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to pen cab, pune to pen taxi, cab from pune to pen, taxi from pune to pen, pune to pen cab service, pune to pen taxi fare, pune to pen one way cab, pune to pen round trip taxi, pune to pen cab booking, cheap pune to pen cab, best pune to pen taxi, sedan pune to pen cab, suv pune to pen taxi, innova pune to pen cab, raigad district cab pune pen"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopencabservice;